import React, { Fragment, useState } from 'react';
import { ComposableMap, Geographies, Geography, Marker,ZoomableGroup } from 'react-simple-maps';
import { geoCentroid } from 'd3-geo';
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import Nanoox from '../../../assets/img/APP-nanoox-1 (003).png';
import Pss from '../../../assets/img/APP pss.png';
import Enviro from '../../../assets/img/APP enviro.png';
import Scapp from '../../../assets/img/APP-scapp.png';
import { motion } from 'framer-motion';

// Mapping service keys to their icons
const serviceIcons = {
  enviro: Enviro,
  nanoox: Nanoox,
  pss: Pss,
  scapp: Scapp,
};

// Capitalize area/region strings to match services keys
const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

function getDeptName(geo) {
  return (
    geo.properties.DPA_DESPRO ||
    geo.properties.NOMBDEP ||
    geo.properties.NAME_1 ||
    ""
  );
}

const PeruMap = ({ servicios, services, selRegion, setSelRegion, setSelArea, hasPeru, peruGeo, handleServiceClick, servicioFiltrado }) => {
  const [hoveredService, setHoveredService] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [containerHeight, setContainerHeight] = useState(1000);

  const handleMapClick = () => setSelectedService(null);
  if (!hasPeru || !peruGeo) return null;

  const pt = { type: "Feature", geometry: { type: "Point", coordinates: [-76.4594, -10.8331] } };
  const dept = peruGeo.features.find(f => booleanPointInPolygon(pt, f));
  if (!dept) return <p>No halló Perú</p>;

  const isSelPeru = selRegion === "peru";
  const centerGeo = geoCentroid(dept);

  const handleWheel = e => {
    e.preventDefault();
    const delta = -e.deltaY / 500;
    setZoom(z => Math.min(Math.max(z + delta, 1), 10));
  };

  const rawSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6">
    <defs>
      <pattern id="hatchPattern" width="6" height="6" patternUnits="userSpaceOnUse">
        <!-- línea diagonal de esquina a esquina -->
        <line x1="0" y1="6" x2="6" y2="0"
              stroke="#000" stroke-width="1"/>
      </pattern>
    </defs>
    <rect width="6" height="6" fill="url(#hatchPattern)"/>
  </svg>
  `;
  const hatchSvg = encodeURIComponent(rawSvg);

  // Base delay para íconos: tras animación de regiones (n regiones * 0.1s)
  const baseServiceDelay =  0.9;
  const iconVariants = {
    initial: { x: 0, y: 0, opacity: 0 },
    animate: (custom) => ({
      x: custom.dx,
      y: -custom.dy,
      opacity: 1,
      transition: {
        delay: custom.index * 0.1,     // escalona cada icono 100 ms
        duration: 0.6,                  // duración de la animación
        ease: "easeOut",                // tipo de easing
      }
    }),
  };



  return (
    <div className="map" style={{ width: '100%', height: '100%', backgroundImage: `url("data:image/svg+xml;utf8,${hatchSvg}")`,backgroundRepeat: 'repeat', }} onClick={handleMapClick}>
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{ scale: 15000, }}
        style={{ width: '100%', height: '45vh'  }}
      >

        <defs>
          <pattern id="hatchPattern" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="6" stroke="#000" strokeWidth="1" />
          </pattern>
        </defs>

        <ZoomableGroup center={centerGeo} zoom={zoom}>
        <Geographies geography={{ type: 'FeatureCollection', features: [dept] }}>
          {({ geographies }) => geographies.map((geo, index) => (
            <Fragment key={geo.rsmKey}>
              <motion.g
                key={geo.rsmKey}
                initial={{ opacity: 0, y: -containerHeight }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, type: 'spring', stiffness: 200, damping: 20 }}
              >
                <Geography
                  geography={geo}
                  onClick={() => { setSelRegion('peru'); setSelArea(null); }}
                  stroke={isSelPeru ? "rgb(233, 78, 26)" : "#c3c3c3"}
                  strokeWidth={isSelPeru ? 0.5 : 0.5}
                  fill={isSelPeru ? "url(#hatchPattern)" : '#222'}
                  style={{ default: { outline: "none" }, hover: { outline: "none" }, pressed: { outline: "none" } }}
                />
                <Marker coordinates={geoCentroid(geo)}>
                  {/* <text textAnchor="middle" dy={4} style={{ fill: "#c3c3c3" }}>
                    {getDeptName(geo)}
                  </text> */}
                  <motion.text
                    initial={{ opacity: 0, y: -containerHeight }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 + 0.2, type: 'spring', stiffness: 200, damping: 20 }}
                    textAnchor="middle"
                    dy={4}
                    style={{ fill: '#c3c3c3', fontSize: '1vw' }}
                  > {getDeptName(geo)}
                  </motion.text>
                </Marker>
              </motion.g>
            </Fragment>
          ))}
        </Geographies>

            {servicios.map(({ area, key, coords }) => {
                  const regionAreaKey = area.split('-').map(capitalize).join('-');
                  const centersMap = services[regionAreaKey] || {};
                  const matchedCenterKey = Object.keys(centersMap).find(k => k.toLowerCase() === key.toLowerCase());
                  // / 1) Obtener info del servicio filtrado
                  let serviceInfo

                  if (servicioFiltrado && matchedCenterKey) {
                    serviceInfo = centersMap[matchedCenterKey][servicioFiltrado];
                  } 

                  console.log('serviceInfo',serviceInfo)
                  return (
                    <g
                      key={key}
                      style={{ cursor: 'pointer' }}
                      // onClick={e => { e.stopPropagation(); setSelectedService(s => (s === key ? null : key)); }}
                      onClick={e => {
                        e.stopPropagation();
                        setSelectedService(s => (s === key ? null : key));
                        setHoveredService(null);
                        handleServiceClick( servicioFiltrado, serviceInfo );
                      }}
                    >
                      <Marker coordinates={[coords.lon, coords.lat]}>
                        <ellipse className="loader-location-shadow" cx={12} cy={40} rx={8} ry={3} pointerEvents="none" />
                        <path
                          className="loader-location"
                          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
                          transform="translate(-12 -2) scale(1.2)"
                        />
                      </Marker>
                    </g>
                  );
            })}

            {/* { selectedService && (() => {
                        const activeKey = hoveredService || selectedService;
                        const serviceItem = servicios.find(s => s.key === activeKey);
                        if (!serviceItem) return null;
                        const { coords, area } = serviceItem;
                        const regionAreaKey = area.split('-').map(capitalize).join('-');
                        const centersMap = services[regionAreaKey] || {};
                        const matchedCenterKey = Object.keys(centersMap)
                          .find(k => k.toLowerCase() === activeKey.toLowerCase());
                        const [centerName] = matchedCenterKey
                          ? matchedCenterKey.split('-')
                          : [activeKey];
                        const centerServices = matchedCenterKey
                          ? centersMap[matchedCenterKey]
                          : {};
                        const activeServicesList = Object
                          .entries(centerServices)
            
                        const R = 85;         
                        const iconSize = 35;  
            
                        return (
                          <Fragment key={activeKey}>
                            <Marker coordinates={[coords.lon, coords.lat]}>
                              <text
                                textAnchor="middle"
                                dy={iconSize + 4}
                                y={(-iconSize / 2) + 38}
                                x={(-iconSize / 2) + 30 }
                                style={{ fill: '#c3c3c3', fontSize: '0.7vw',  }}
                              >
                                {capitalize(centerName)}
                              </text>
                            </Marker>
            
                            {activeServicesList.map((img, idx) => {
                              const angle = (2 * Math.PI / activeServicesList.length) * idx  ;
                              const dx = Math.cos(angle) * R;
                              const dy = Math.sin(angle) * R;
                              console.log('name',img[1].status_service)
                              return (
                                <Marker
                                  key={idx}
                                  coordinates={[coords.lon, coords.lat]}
                                >
                                  <motion.g 
                                    initial="initial"
                                    animate="animate"
                                    custom={{ dx, dy, idx }}
                                    variants={iconVariants}
                                      onClick={e => {
                                        e.stopPropagation();
                                        handleServiceClick(img[0], img[1]);
                                      }}
                                      whileHover={{ scale: 1.1 }}
                                  >
                                    <image
                                      
                                      href={serviceIcons[img[0]]}
                                      width={'14%'}
                                      height={'14%'}
                                      opacity={img[1].status_service ? '': 0}
                                      x={(-iconSize / 2) - 27 }
                                      y={(-iconSize / 2) + 5}
                                      style={{ cursor: 'pointer',  }}
                                    />
                                  </motion.g>
                                </Marker>
                              );
                            })}
                          </Fragment>
                        );
            })()} */}

          
        </ZoomableGroup>
      </ComposableMap>

      <style jsx>{`
        .info-card-peru {
          background: #1f1f1f;
          border: 0.01vw solid #e94e1a;
          border-radius: 0.4vw;
          box-shadow: 0 0.5vw 1vw rgba(233,78,26,0.15);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          font-size: 0.7vw;
          padding: 0.5vw;
          pointer-events: auto;
        }
        .services-container {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          flex-wrap: wrap;
          justify-content: center;
          gap: 0.5vw;
          margin-bottom: 0.5vh;
        }
        .service-icon {
          width: 3vw;
          cursor: pointer;
          transition: transform 0.2s ease-in-out;
        }
        .service-icon:hover {
          transform: scale(1.1);
        }
        .center-name-gps {
          color: #fff;
          font-size: 0.8vw;
          margin-top: 0.5vh;
          text-align: center;
        }
        .coords {
          display: flex;
          justify-content: center;
          color: #c3c3c3;
          font-size: 0.6vw;
          margin-top: 0.2vh;
        }
        .loader-location {
          fill: #e94e1a;
          stroke: #e94e1a;
          stroke-width: 1;
          transform-origin: center bottom;
          animation: animMarker 0.4s ease-in-out infinite alternate;
          cursor: pointer;

        }
        .loader-location-shadow {
          fill: rgba(0, 0, 0, 0.2);
        }
        @keyframes animMarker {
          0%   { transform: translateY(0.1vw); }
          100% { transform: translateY(-0.1vw); }
        }
      `}</style>
    </div>
  );
};

export default PeruMap;
